function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/* Pure, serializable classic rules. Network callers inject Saito's rollDice(sides).
 * externalCards delegates private custody to the GameTemplate encrypted deck.
 */
(function (root, factory) {
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) module.exports = factory(require('./map'));else root.ConquestEngine = factory(root.ConquestMap);
})(typeof globalThis !== 'undefined' ? globalThis : this, function (Map) {
  'use strict';

  var ids = Object.keys(Map.territories);
  var cards = {};
  ids.forEach(function (id) {
    cards[id] = {
      id: id,
      territory: id,
      symbol: Map.territories[id].symbol,
      name: Map.territories[id].name
    };
  });
  ['wild_1', 'wild_2'].forEach(function (id) {
    cards[id] = {
      id: id,
      territory: null,
      symbol: 'wild',
      name: 'Wild card'
    };
  });
  function assert(ok, message) {
    if (!ok) throw new Error(message);
  }
  function integer(n, min, max) {
    return Number.isSafeInteger(n) && n >= min && n <= max;
  }
  function random(s, sides, roll) {
    var result;
    if (roll) result = roll(sides);else {
      s.seed = Math.imul(s.seed, 1664525) + 1013904223 >>> 0;
      result = 1 + Math.floor(s.seed / 4294967296 * sides);
    }
    assert(integer(result, 1, sides), 'Random source returned an invalid die');
    return result;
  }
  function shuffle(s, values, roll) {
    var a = values.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = random(s, i + 1, roll) - 1;
      var _ref = [a[j], a[i]];
      a[i] = _ref[0];
      a[j] = _ref[1];
    }
    return a;
  }
  function player(s, p) {
    return s.players.find(function (x) {
      return x.id === p;
    });
  }
  function ownedTerritories(s, p) {
    return ids.filter(function (id) {
      return s.territories[id].owner === p;
    });
  }
  function reinforcementFor(s, p) {
    var owned = ownedTerritories(s, p);
    if (!owned.length) return 0;
    return Math.max(3, Math.floor(owned.length / 3)) + Object.values(Map.continents).filter(function (c) {
      return c.territories.every(function (t) {
        return s.territories[t].owner === p;
      });
    }).reduce(function (sum, c) {
      return sum + c.bonus;
    }, 0);
  }
  function isValidSet(set) {
    if (!Array.isArray(set) || set.length !== 3 || new Set(set).size !== 3 || set.some(function (id) {
      return !cards[id];
    })) return false;
    var symbols = set.map(function (id) {
      return cards[id].symbol;
    });
    return symbols.includes('wild') || new Set(symbols).size === 1 || new Set(symbols).size === 3;
  }
  function validTrades(s, p) {
    var _player;
    var hand = ((_player = player(s, p)) === null || _player === void 0 ? void 0 : _player.cards) || [];
    var result = [];
    for (var i = 0; i < hand.length; i++) for (var j = i + 1; j < hand.length; j++) for (var k = j + 1; k < hand.length; k++) {
      var set = [hand[i], hand[j], hand[k]];
      if (isValidSet(set)) result.push(set);
    }
    return result;
  }
  function tradeValue(n) {
    return n < 5 ? 4 + n * 2 : 15 + (n - 5) * 5;
  }
  function canAttack(s, from, to) {
    return !!(Map.territories[from] && Map.territories[to] && s.territories[from].owner === s.currentPlayer && s.territories[to].owner !== s.currentPlayer && s.territories[to].owner !== null && s.territories[from].armies > 1 && Map.territories[from].neighbors.includes(to));
  }
  function canFortify(s, from, to) {
    return !!(Map.territories[from] && Map.territories[to] && s.territories[from].owner === s.currentPlayer && s.territories[to].owner === s.currentPlayer && s.territories[from].armies > 1 && Map.territories[from].neighbors.includes(to));
  }
  function automaticPhaseEnd(s) {
    if (s.cardDraw || s.cardTransfer || s.mustTrade) return null;
    var legal = s.phase === 'attack' ? canAttack : s.phase === 'fortify' ? canFortify : null;
    if (!legal || ids.some(function (from) {
      return Map.territories[from].neighbors.some(function (to) {
        return legal(s, from, to);
      });
    })) return null;
    if (s.phase === 'attack') return {
      type: 'end_attack',
      message: 'No sector with more than one army borders an opponent or neutral force.'
    };
    var spare = ownedTerritories(s, s.currentPlayer).some(function (id) {
      return s.territories[id].armies > 1;
    });
    return {
      type: 'end_turn',
      message: spare ? 'No sector with spare armies borders a friendly sector.' : 'No sector has more than one army.'
    };
  }
  function log(s, message) {
    s.log.push(message);
    if (s.log.length > 60) s.log.shift();
  }
  function campaignNumber(s) {
    return s.round || s.turn || 1;
  }
  function recordStatistics(s, id, values) {
    var dice = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    // Old saved games can start collecting here without inventing past results.
    if (!s.statistics) s.statistics = {
      sinceCampaign: campaignNumber(s),
      partial: true,
      totals: {},
      campaigns: {}
    };
    var stats = s.statistics,
      campaign = campaignNumber(s);
    if (stats.version !== 2) {
      stats.version = 2;
      stats.extendedPartial = true;
    }
    var current = stats.campaigns[campaign] || (stats.campaigns[campaign] = {});
    for (var _i = 0, _arr = [stats.totals, current]; _i < _arr.length; _i++) {
      var group = _arr[_i];
      var playerStats = group[id] || (group[id] = {
        dice: [0, 0, 0, 0, 0, 0],
        lost: 0,
        defeated: 0
      });
      var _iterator = _createForOfIteratorHelper(dice),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var die = _step.value;
          playerStats.dice[die - 1]++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var _i2 = 0, _Object$entries = Object.entries(values); _i2 < _Object$entries.length; _i2++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        playerStats[key] = (playerStats[key] || 0) + value;
      }
    }
  }
  function recordBattleStatistics(s, battle) {
    for (var _i3 = 0, _arr2 = [[battle.before.attackerOwner, battle.attackerDice, battle.attackerLosses, battle.defenderLosses], [battle.before.defenderOwner, battle.defenderDice, battle.defenderLosses, battle.attackerLosses]]; _i3 < _arr2.length; _i3++) {
      var _arr2$_i = _slicedToArray(_arr2[_i3], 4),
        id = _arr2$_i[0],
        dice = _arr2$_i[1],
        lost = _arr2$_i[2],
        defeated = _arr2$_i[3];
      recordStatistics(s, id, {
        lost: lost,
        defeated: defeated
      }, dice);
    }
  }
  function beginTurn(s, p) {
    s.currentPlayer = p;
    s.phase = 'reinforce';
    s.reinforcements = reinforcementFor(s, p);
    s.capturedThisTurn = false;
    s.cardBonusUsed = false;
    s.eliminationTrade = false;
    s.mustTrade = player(s, p).cardCount >= 5;
    s.turn++;
    s.lastBattle = null;
    recordStatistics(s, p, {
      earned: s.reinforcements
    });
    log(s, "Player ".concat(p, " receives ").concat(s.reinforcements, " reinforcements."));
  }
  function nextPlayer(s) {
    for (var i = 1; i <= s.players.length; i++) {
      var p = (s.currentPlayer - 1 + i) % s.players.length + 1;
      if (!player(s, p).eliminated) return p;
    }
    return s.currentPlayer;
  }
  function finishTurn(s) {
    beginTurn(s, nextPlayer(s));
  }
  function finishSetupStep(s) {
    if (Object.values(s.setupRemaining).every(function (n) {
      return n === 0;
    })) {
      beginTurn(s, s.firstPlayer);
      return;
    }
    do {
      s.currentPlayer = s.currentPlayer % s.players.length + 1;
    } while (s.setupRemaining[s.currentPlayer] === 0);
    s.setupPlacementsLeft = s.players.length === 2 ? Math.min(2, s.setupRemaining[s.currentPlayer]) : 1;
    s.setupNeutral = false;
  }
  function createGame(options, roll) {
    options = options || {};
    var n = typeof options.players === 'number' ? options.players : (options.players || []).length;
    assert(integer(n, 2, 6), 'Classic Conquest supports 2 to 6 players');
    var s = {
      version: 1,
      seed: (Number(options.seed) || 1) >>> 0,
      players: [],
      territories: {},
      currentPlayer: 1,
      firstPlayer: 1,
      phase: 'claim',
      turn: 0,
      reinforcements: 0,
      setupRemaining: {},
      setupPlacementsLeft: 1,
      setupNeutral: false,
      tradedSets: 0,
      cardBonusUsed: false,
      mustTrade: false,
      eliminationTrade: false,
      capturedThisTurn: false,
      externalCards: !!options.externalCards,
      deck: [],
      discard: [],
      cardDraw: null,
      cardTransfer: null,
      occupation: null,
      lastBattle: null,
      winner: null,
      log: [],
      statistics: {
        version: 2,
        sinceCampaign: 1,
        partial: false,
        totals: {},
        campaigns: {}
      }
    };
    var initial = {
      2: 40,
      3: 35,
      4: 30,
      5: 25,
      6: 20
    }[n];
    for (var p = 1; p <= n; p++) {
      s.players.push({
        id: p,
        cards: [],
        cardCount: 0,
        eliminated: false
      });
      s.setupRemaining[p] = initial;
    }
    ids.forEach(function (id) {
      return s.territories[id] = {
        owner: null,
        armies: 0
      };
    });
    // A common synchronized draw selects the starting player, resolving the board-game roll-off in one draw.
    s.firstPlayer = s.currentPlayer = random(s, n, roll);
    if (n === 2 || options.setup === 'quick') {
      var order = shuffle(s, ids, roll);
      var owners = n === 2 ? [s.firstPlayer, s.firstPlayer % 2 + 1, 0] : Array.from({
        length: n
      }, function (_, i) {
        return (s.firstPlayer - 1 + i) % n + 1;
      });
      if (n === 2) s.setupRemaining[0] = 40;
      order.forEach(function (id, i) {
        var owner = owners[i % owners.length];
        s.territories[id] = {
          owner: owner,
          armies: 1
        };
        s.setupRemaining[owner]--;
      });
      s.phase = 'setup';
      s.setupPlacementsLeft = n === 2 ? 2 : 1;
      if (options.setup === 'quick') {
        // Convenience setup: distribute the full initial army allotment before the first turn.
        for (var _i4 = 0, _Object$keys = Object.keys(s.setupRemaining); _i4 < _Object$keys.length; _i4++) {
          var key = _Object$keys[_i4];
          var _p = Number(key);
          var own = ownedTerritories(s, _p);
          while (s.setupRemaining[_p] > 0) {
            var id = own[random(s, own.length, roll) - 1];
            s.territories[id].armies++;
            s.setupRemaining[_p]--;
          }
        }
        beginTurn(s, s.firstPlayer);
      }
    }
    if (!s.externalCards) s.deck = shuffle(s, Object.keys(cards), roll);
    log(s, options.setup === 'quick' ? 'Armies automatically deployed.' : 'The campaign begins.');
    return s;
  }
  function drawCard(s, roll) {
    var p = player(s, s.currentPlayer);
    if (s.externalCards) {
      p.cardCount++;
      s.cardDraw = {
        player: p.id,
        count: 1
      };
      return;
    }
    if (!s.deck.length) {
      s.deck = shuffle(s, s.discard, roll);
      s.discard = [];
    }
    if (s.deck.length) {
      p.cards.push(s.deck.pop());
      p.cardCount = p.cards.length;
    }
  }
  function endAttack(s, roll) {
    if (s.capturedThisTurn) drawCard(s, roll);
    s.phase = 'fortify';
    log(s, "Player ".concat(s.currentPlayer, " finishes attacking."));
  }
  function occupy(s, count) {
    var o = s.occupation;
    assert(o && integer(count, o.min, o.max), 'Move at least the final attack dice count and leave one army behind');
    s.territories[o.from].armies -= count;
    s.territories[o.to].armies = count;
    s.occupation = null;
    s.phase = 'attack';
    if (s.players.filter(function (p) {
      return !p.eliminated;
    }).length === 1) {
      s.winner = s.currentPlayer;
      s.phase = 'gameover';
      log(s, "Player ".concat(s.currentPlayer, " wins the campaign."));
      return;
    }
    if (player(s, s.currentPlayer).cardCount >= 6 && o.eliminated) {
      s.phase = 'reinforce';
      s.eliminationTrade = true;
      s.mustTrade = true;
      s.reinforcements = 0;
    }
  }
  function battle(s, a, roll) {
    assert(canAttack(s, a.from, a.to), 'Attack an adjacent enemy from a territory with at least two armies');
    var from = s.territories[a.from],
      to = s.territories[a.to];
    var dice = a.dice === undefined ? Math.min(3, from.armies - 1) : a.dice;
    assert(integer(dice, 1, Math.min(3, from.armies - 1)), 'Invalid number of attack dice');
    var defenderDice = Array.from({
      length: Math.min(2, to.armies)
    }, function () {
      return random(s, 6, roll);
    }).sort(function (a, b) {
      return b - a;
    });
    var attackerDice = Array.from({
      length: dice
    }, function () {
      return random(s, 6, roll);
    }).sort(function (a, b) {
      return b - a;
    });
    var attackerLosses = 0,
      defenderLosses = 0;
    for (var i = 0; i < Math.min(attackerDice.length, defenderDice.length); i++) {
      if (attackerDice[i] > defenderDice[i]) defenderLosses++;else attackerLosses++;
    }
    var before = {
      attacker: from.armies,
      defender: to.armies,
      attackerOwner: from.owner,
      defenderOwner: to.owner
    };
    from.armies -= attackerLosses;
    to.armies -= defenderLosses;
    s.lastBattle = {
      from: a.from,
      to: a.to,
      attackerDice: attackerDice,
      defenderDice: defenderDice,
      attackerLosses: attackerLosses,
      defenderLosses: defenderLosses,
      conquered: to.armies === 0
    };
    s.battleRolls.push(_objectSpread(_objectSpread({}, s.lastBattle), {}, {
      before: before
    }));
    recordBattleStatistics(s, s.battleRolls[s.battleRolls.length - 1]);
    if (to.armies === 0) {
      var previousOwner = to.owner;
      to.owner = s.currentPlayer;
      s.capturedThisTurn = true;
      recordStatistics(s, s.currentPlayer, {
        territoriesWon: 1
      });
      recordStatistics(s, previousOwner, {
        territoriesLost: 1
      });
      var eliminated = false;
      if (previousOwner > 0 && !ownedTerritories(s, previousOwner).length) {
        eliminated = true;
        var loser = player(s, previousOwner),
          winner = player(s, s.currentPlayer);
        loser.eliminated = true;
        if (s.externalCards) {
          s.cardTransfer = {
            from: previousOwner,
            to: s.currentPlayer,
            count: loser.cardCount
          };
          winner.cardCount += loser.cardCount;
          loser.cardCount = 0;
        } else {
          var _winner$cards;
          (_winner$cards = winner.cards).push.apply(_winner$cards, _toConsumableArray(loser.cards));
          loser.cards = [];
          winner.cardCount = winner.cards.length;
          loser.cardCount = 0;
        }
        log(s, "Player ".concat(previousOwner, " is eliminated."));
      }
      s.occupation = {
        from: a.from,
        to: a.to,
        min: dice,
        max: from.armies - 1,
        eliminated: eliminated
      };
      s.phase = 'occupy';
      log(s, "Player ".concat(s.currentPlayer, " captures ").concat(Map.territories[a.to].name, "."));
    }
  }
  function applyAction(state, action, roll) {
    assert(action && _typeof(action) === 'object', 'An action is required');
    assert(action.player === state.currentPlayer, 'It is not your turn');
    assert(state.phase !== 'gameover', 'The campaign is over');
    var s = JSON.parse(JSON.stringify(state));
    var a = action;
    var p = player(s, s.currentPlayer);
    // One-action events are consumed by the network adapter before its next dispatch.
    s.cardDraw = null;
    s.cardTransfer = null;
    if (a.type === 'claim') {
      assert(s.phase === 'claim', 'Territory claiming has finished');
      assert(Map.territories[a.territory] && s.territories[a.territory].owner === null, 'Choose an unclaimed territory');
      s.territories[a.territory] = {
        owner: p.id,
        armies: 1
      };
      s.setupRemaining[p.id]--;
      s.currentPlayer = p.id % s.players.length + 1;
      if (ids.every(function (id) {
        return s.territories[id].owner !== null;
      })) {
        s.phase = 'setup';
        s.setupPlacementsLeft = 1;
      }
    } else if (a.type === 'place') {
      var t = s.territories[a.territory];
      var count = a.count === undefined ? 1 : a.count;
      assert(t, 'Unknown territory');
      if (s.phase === 'setup') {
        var owner = s.setupNeutral ? 0 : p.id;
        assert(t.owner === owner, 'Place armies on the indicated army’s territory');
        assert(integer(count, 1, Math.min(s.setupPlacementsLeft, s.setupRemaining[owner])), 'Invalid initial deployment count');
        t.armies += count;
        s.setupRemaining[owner] -= count;
        s.setupPlacementsLeft -= count;
        if (s.setupPlacementsLeft === 0) {
          if (s.players.length === 2 && !s.setupNeutral && s.setupRemaining[0] > 0) {
            s.setupNeutral = true;
            s.setupPlacementsLeft = 1;
          } else finishSetupStep(s);
        }
      } else {
        assert(s.phase === 'reinforce', 'You cannot deploy armies in this phase');
        assert(!s.mustTrade, 'Trade cards before deploying');
        assert(t.owner === p.id, 'Reinforce your own territory');
        assert(integer(count, 1, s.reinforcements), 'Invalid reinforcement count');
        t.armies += count;
        s.reinforcements -= count;
        if (s.reinforcements === 0) {
          s.phase = 'attack';
          s.eliminationTrade = false;
        }
      }
    } else if (a.type === 'trade') {
      var _s$discard;
      assert(s.phase === 'reinforce', 'Trade cards during reinforcement');
      assert(!s.eliminationTrade || s.mustTrade, 'The mandatory elimination trades are complete');
      assert(isValidSet(a.cards), 'Select three matching symbols, three different symbols, or a wild set');
      assert(s.externalCards ? p.cardCount >= 3 : a.cards.every(function (id) {
        return p.cards.includes(id);
      }), 'You do not hold these cards');
      var eligible = a.cards.map(function (id) {
        return cards[id].territory;
      }).filter(function (id) {
        return id && s.territories[id].owner === p.id;
      });
      var bonus = a.territory || eligible[0];
      if (a.territory) assert(eligible.includes(a.territory), 'The territory bonus must match an owned traded card');
      var territoryBonus = 0;
      if (!s.cardBonusUsed && bonus) {
        s.territories[bonus].armies += 2;
        s.cardBonusUsed = true;
        territoryBonus = 2;
      }
      var value = tradeValue(s.tradedSets++);
      s.reinforcements += value;
      recordStatistics(s, p.id, {
        earned: value + territoryBonus
      });
      p.cards = p.cards.filter(function (id) {
        return !a.cards.includes(id);
      });
      p.cardCount -= 3;
      if (!s.externalCards) (_s$discard = s.discard).push.apply(_s$discard, _toConsumableArray(a.cards));
      s.mustTrade = p.cardCount >= 5;
      log(s, "Player ".concat(p.id, " trades a set for ").concat(value, " armies."));
    } else if (a.type === 'attack') {
      assert(s.phase === 'attack', 'Finish reinforcement before attacking');
      s.battleSequence = (s.battleSequence || 0) + 1;
      s.battleRolls = [];
      battle(s, a, roll);
      if (a.blitz) {
        var rounds = 1;
        while (s.phase === 'attack' && s.territories[a.from].armies > 1 && rounds < 10000) {
          battle(s, {
            from: a.from,
            to: a.to,
            dice: Math.min(a.dice || 3, s.territories[a.from].armies - 1)
          }, roll);
          rounds++;
        }
        s.lastBattle.rounds = rounds;
      }
      var attacker = s.battleRolls[0].before.attackerOwner,
        defender = s.battleRolls[0].before.defenderOwner;
      // One attack order (including all Blitz rolls): capture wins, otherwise defense holds.
      recordStatistics(s, s.lastBattle.conquered ? attacker : defender, {
        wins: 1
      });
      recordStatistics(s, s.lastBattle.conquered ? defender : attacker, {
        losses: 1
      });
      var lost = s.battleRolls.reduce(function (sum, b) {
          return sum + b.attackerLosses;
        }, 0),
        defeated = s.battleRolls.reduce(function (sum, b) {
          return sum + b.defenderLosses;
        }, 0);
      var defendingForce = defender === 0 ? 'Neutral forces' : "Player ".concat(defender);
      log(s, "Campaign ".concat(campaignNumber(s), " \xB7 Player ").concat(attacker, " attacks ").concat(Map.territories[a.to].name, " from ").concat(Map.territories[a.from].name, " (").concat(s.battleRolls.length, " roll").concat(s.battleRolls.length === 1 ? '' : 's', ")."));
      log(s, "Losses / defeated \xB7 Player ".concat(attacker, ": ").concat(lost, " lost, ").concat(defeated, " defeated. ").concat(defendingForce, ": ").concat(defeated, " lost, ").concat(lost, " defeated."));
      // Resolve automatic occupation in the same signed action, after blitz stops.
      if (a.steamroll && s.phase === 'occupy') occupy(s, s.occupation.max);
    } else if (a.type === 'occupy') {
      assert(s.phase === 'occupy', 'There is no pending occupation');
      occupy(s, a.count);
    } else if (a.type === 'end_attack') {
      assert(s.phase === 'attack', 'You cannot finish attacking yet');
      endAttack(s, roll);
    } else if (a.type === 'fortify') {
      assert(s.phase === 'fortify', 'Fortify after finishing attacks');
      assert(canFortify(s, a.from, a.to), 'Fortify between two adjacent owned territories');
      assert(integer(a.count, 1, s.territories[a.from].armies - 1), 'Leave at least one army behind');
      s.territories[a.from].armies -= a.count;
      s.territories[a.to].armies += a.count;
      log(s, "Player ".concat(p.id, " fortifies ").concat(Map.territories[a.to].name, "."));
      finishTurn(s);
    } else if (a.type === 'end_turn') {
      assert(s.phase === 'attack' || s.phase === 'fortify', 'Complete the current phase first');
      if (s.phase === 'attack') endAttack(s, roll);
      finishTurn(s);
    } else {
      throw new Error('Unknown action');
    }
    return s;
  }
  return {
    createGame: createGame,
    applyAction: applyAction,
    ownedTerritories: ownedTerritories,
    reinforcementFor: reinforcementFor,
    isValidSet: isValidSet,
    validTrades: validTrades,
    tradeValue: tradeValue,
    canAttack: canAttack,
    canFortify: canFortify,
    automaticPhaseEnd: automaticPhaseEnd,
    campaignNumber: campaignNumber,
    cards: cards
  };
});